



import {Component, Vue} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {SvgRender}
})
export default class BackButton extends Vue {

  private created() {
    // TODO
  }

  private onClickToButton(): void {
    this.$emit('onClick')
  }
}
